<template>
  <div id="app">
    <router-view :key="this.$route.fullPath"/>
  </div>
</template>

<script>
import {getQueryObject} from "@/utils";
import {setToken} from "@/utils/auth";

export default {
  mounted() {
    const tokenData = getQueryObject(window.location.href)
    if (tokenData.token) {
      setToken(tokenData.token)
      this.$store.dispatch('setToken', tokenData.token)
    }
  }
}

</script>

<style lang="scss">
#app {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 20px;
  font-size: 20px;
  background-color: #fff;
}
</style>
